import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {LoadingService} from '../loading/loading.service';
import {Observable, throwError, catchError} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {DataService} from '../data.service';

@Injectable()
export class ReportsService extends DataService {

  private tmssloader;

  private baseURI = this.apiUri + '/public/reports/';
  private faicURI = this.apiUri + '/faicList';
  private frtURI = this.apiUri + '/frtList';
  private hhgURI = this.apiUri + '/hhgList';
  private faicXlsxURI = this.apiUri + '/faicListxlsx';
  private frtTspURI = this.apiUri + '/frtTspList';

  constructor(protected http: HttpClient, private router: Router, private loader: LoadingService) {
    super(http);
    this.tmssloader = this.loader;
  }

  // handling error
  errorHandler(error: any): any {
    if (error.status < 400) {
      return throwError(new Error(error.status));
    }
  }


  getCustomerMailReport(mailList: any, orderCol: string, sortDirParam: boolean): Observable<any> {
    // This will be changed once sorting  fuctionality added.
    const orderByColumn = orderCol != null ? orderCol : 'N';
    const sortDir = sortDirParam != null ? sortDirParam : true;

    let sortDirString: string;
    if (sortDir) {
      sortDirString = 'ASC';
    } else {
      sortDirString = 'DESC';
    }
    this.setUri(this.apiUri + '/customerMailListReport/' + orderByColumn + '/' + sortDirString + '/' + mailList);
    return this.http.get(this.apiUri + '/customerMailListReport/' + orderByColumn + '/' + sortDirString + '/' + mailList).pipe(catchError(this.handleError));

  }

  getTSPMailReport(mailList: any): Observable<any> {
    this.setUri(this.apiUri + '/tspMailListReport/' + mailList);
    return this.http.get(this.apiUri + '/tspMailListReport/' + mailList).pipe(catchError(this.handleError));
  }

  getAllUsersMailReport(organizationId): Observable<any> {
    this.setUri(this.apiUri + '/allUsersMailListReport/' + organizationId);
    return this.http.get(this.apiUri + '/allUsersMailListReport/' + organizationId).pipe(catchError(this.handleError));
  }


  // call to server for faic list report
  getFAICDetails(orderCol: string, sortDirParam: boolean): Observable<any> {
    const orderByColumn = orderCol != null ? orderCol : 'faicDisplay';
    const sortDir = sortDirParam != null ? sortDirParam : true;

    let sortDirString: string;
    if (sortDir) {
      sortDirString = 'ASC';
    } else {
      sortDirString = 'DESC';
    }

    const faicUrl = this.faicURI + '/' + orderByColumn + '/' + sortDir;

    return this.http.get<any>(faicUrl)
    .pipe(catchError(this.handleError));

  }

  // call to server for frt list report
  getFRTDetails(orderCol: string, sortDirParam: boolean, startDate: number, endDate: number): Observable<any> {
    const orderByColumn = orderCol != null ? orderCol : 'frtDisplay';
    const sortDir = sortDirParam != null ? sortDirParam : true;
    let sortDirString: string = (sortDir) ? 'ASC' : 'DESC';
    const faicUrl = this.frtURI + '/' + orderByColumn + '/' + sortDir + '/' + startDate + '/' + endDate;
    return this.http.get<any>(faicUrl).pipe(catchError(this.handleError));
  }

  // call to server for hhg list report
  getHHGDetails(orderCol: string, sortDirParam: boolean, startDate: number, endDate: number): Observable<any> {
    const orderByColumn = orderCol != null ? orderCol : 'hhgDisplay';
    const sortDir = sortDirParam != null ? sortDirParam : true;
    let sortDirString: string = (sortDir) ? 'ASC' : 'DESC';
    const faicUrl = this.hhgURI + '/' + orderByColumn + '/' + sortDir + '/' + startDate + '/' + endDate;
    return this.http.get<any>(faicUrl).pipe(catchError(this.handleError));
  }

  // call to server for frt list report
  getFrtTspDetails(orderCol: string, sortDirParam: boolean, startDate: number, endDate: number): Observable<any> {
    const orderByColumn = orderCol != null ? orderCol : 'frtDisplay';
    const sortDir = sortDirParam != null ? sortDirParam : true;
    let sortDirString: string = (sortDir) ? 'ASC' : 'DESC';
    const faicUrl = this.frtTspURI + '/' + orderByColumn + '/' + sortDir + '/' + startDate + '/' + endDate;
    return this.http.get<any>(faicUrl).pipe(catchError(this.handleError));
  }

  // call to server for faic list report
  getFAICXlsx(): Observable<any> {

    const faicUrl = this.faicXlsxURI;

    return this.http.get<any>(faicUrl)
    .pipe(catchError(this.handleError));

  }

  customerMailReportExport(mailingList): Observable<any> {
    return this.http.post(this.apiUri + '/customerMailingReportExport', mailingList);
  }

  tspMailReportExport(mailingList): Observable<any> {
    return this.http.post(this.apiUri + '/tspMailReportExport', mailingList);
  }

  usersListExport(mailingList): Observable<any> {
    return this.http.post(this.apiUri + '/usersListExport', mailingList);
  }
}
